import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { ServerProvider } from '../../providers/server/server';
import { LoadingController, Loading } from 'ionic-angular';
import { ReportDetailedPage} from '../report-detailed/report-detailed'
import {ReportMonthlyPage} from '../report-monthly/report-monthly';

@Component({
    selector: 'page-report',
    templateUrl: 'report.html',
})
export class ReportPage {

    monthlyTab: any;
    detailTab: any;

    constructor(public navCtrl: NavController, public navParams: NavParams,
                public server: ServerProvider, public loadingCtrl: LoadingController
    ) {

        this.monthlyTab = ReportMonthlyPage;
        this.detailTab = ReportDetailedPage;
    }

}



// WEBPACK FOOTER //
// ./src/pages/report/report.ts